// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"0118b0a8","249":"0d0d4ee1","277":"0cf1a7d5","352":"3859aed4","478":"27f13592","518":"8a30dd9c","539":"f0700b78","552":"aff4fc4e","565":"6719be52","591":"6ec2cb2e","849":"9df8b091","934":"21f0b84e"}[chunkId] + ".chunk.js";
};